import { useMyTenants, useSwitchTenant } from '../api/queries';
import { useSession } from '../auth/session';
import { useTranslate } from '../i18n/useTranslate';

/**
 * Kurum seçici (SEOAI-22). Seçim sunucuya gider ve YENİ TOKEN çifti döner:
 * aktif kiracı jetonun içindedir, istemci iddiası değildir.
 */
export function TenantSwitcher() {
  const t = useTranslate();
  const activeTenantId = useSession((s) => s.tenantId);
  /*
   * "Seçecek başka kurum var mı" sorusunu SUNUCU yanıtlar (SEOAI-80 ikinci
   * inceleme). Önce liste çekilip uzunluğuna bakılıyordu; yani tek kurumlu
   * kullanıcı, sırf kendisine GÖSTERİLMEYECEK bir denetimin kararı için her
   * açılışta /me/tenants'a gidiyordu. Karar jeton yanıtından geliyor; liste
   * yalnızca gerçekten seçenek varken ve İSİMLERİ göstermek için çekilir.
   */
  const hasMultiple = useSession((s) => s.hasMultipleTenants);
  const tenants = useMyTenants(hasMultiple);
  const switchTenant = useSwitchTenant();

  if (!hasMultiple || !tenants.data) return null;

  return (
    <label className="switcher">
      {t('tenant.label')}
      <select
        value={activeTenantId ?? ''}
        disabled={switchTenant.isPending}
        onChange={(event) => switchTenant.mutate(event.target.value)}
      >
        {!activeTenantId && <option value="" disabled />}
        {tenants.data.map((tenant) => (
          <option key={tenant.tenantId} value={tenant.tenantId}>
            {tenant.name}
          </option>
        ))}
      </select>
      {switchTenant.isPending && <span className="hint">{t('tenant.switching')}</span>}
    </label>
  );
}
